module.exports = __webpack_public_path__ + "media/src/images/logo-light-bg-fbfd1649beec0e616afa006aaa82d840.png";